<template>
  <div class="absolute top-0 left-0 bottom-0 right-0" :style='style' >
  </div>
</template>
<script>
function round(p, n) {
  return (p % n < n / 2 ? p - (p % n) : p + n - (p % n));
}

export default {
  inject: ['api'],
  props:{
    renderTools:{
      type: Object,
      required: true
    },
    grid:{
      type:Object,
      default() {
        return {
          x:1,
          y:1
        }
      }
    }
  },
  data() {
    return {
      bb:{
        left:0,right:0,
        top:0,bottom:0
      }
    }
  },
  methods:{
    onPointerTapCanvas({x,y,hits,cancelSelection}) {
      //if (hits.length > 1) {
        //return;
      //}
      console.log('tap evt', x, y);

      const worldPos = this.renderTools.screenToWorldWithOffset({x,y});
      const snappedPos = this.renderTools.snapToGrid({
        position:worldPos,
        grid:this.grid
      });

      console.log('worldPos', worldPos.x, worldPos.y);
      console.log('snappedPos', snappedPos.x, snappedPos.y);
      this.$emit('world-click', snappedPos);

      cancelSelection();
    },
    snapToGrid({x,y}) {
      return {
        x:round(x, this.grid.x),
        y:round(y, this.grid.y)
      }
    }
  },
  mounted() {
    this.bb = this.$el.getBoundingClientRect();

    this.renderTools.stageInteractive.on('hammertap', this.onPointerTapCanvas);
  },
  beforeDestroy() {
    this.renderTools.stageInteractive.off('hammertap', this.onPointerTapCanvas);
  },
  computed:{
    style() {
      const {x,y} = this.renderTools.getCenter();
      console.log('center', x,y);
      const unit = this.renderTools.getBlockSize();
      console.log('unit', unit);
      const gridx = unit.x;
      const gridy = unit.y;
      const offsetx = x + unit.x/2;
      const offsety = y + unit.y/2;
      const color='#636363';

      const bb = this.bb;
      //const center = {
        //x:(bb.left + bb.right)/2,
        //y:(bb.top + bb.bottom)/2
      //}
      //const center = {
        //x:0,
        //y:0
      //}
      console.log('send in', x,y);
      const center = this.renderTools.centerThing({x:0,y:0});

      center.x += unit.x/2;
      center.y += unit.y/2;
      //center.x += 
      //const center = {
        //x:20,
        //y:20
      //}
      //center.x += x + unit.x/2;
      //center.y += y + unit.y/2;
      console.log('center', center.x, center.y);
      return {
        'background-image': `repeating-linear-gradient(0deg, transparent, transparent ${gridx}px, ${color} ${gridx}px, ${color} ${gridx+1}px), repeating-linear-gradient(-90deg, transparent, transparent ${gridy}px, ${color} ${gridy}px, ${color} ${gridy+1}px)`,
        //'background-image':`url(${this.api.makeImageUrlEditor('placeholder.png')})`,
        'background-size': `${gridx+1}px ${gridy+1}px`,
        'background-position': `${center.x}px ${center.y}px`,
        //'transform': `translate(${center.x}px, ${center.y}px)`,
        'pointer-events': 'none'

      }
    }
  }
}
</script>
<style>
.instant-add-grid {
    background-image:
    repeating-linear-gradient(0deg, transparent, transparent 70px, #CCC 70px, #CCC 71px),
    repeating-linear-gradient(-90deg, transparent, transparent 70px, #CCC 70px, #CCC 71px);
}
</style>
